module.exports = __webpack_public_path__ + "static/media/styledmenu-hamburger.b2df67b1.svg";